import appConfig from '@/features/app/constants/app-config';
import { getApps, initializeApp } from 'firebase/app';
import { getMessaging, isSupported, type Messaging } from 'firebase/messaging';

let messagingPromise: Promise<Messaging | null> | null = null;

export default async function getFirebaseMessaging(): Promise<Messaging | null> {
  if (typeof window === 'undefined' || window.ReactNativeWebView) return null;
  if (!(await isSupported())) return null;

  const { firebase } = appConfig;
  if (!firebase.apiKey) return null;
  if (messagingPromise) return messagingPromise;

  messagingPromise = (async () => {
    const app = getApps().length > 0 ? getApps()[0]! : initializeApp(firebase);
    return getMessaging(app);
  })();
  return messagingPromise;
}
